export function getLogoWalletBlockChain(network: string) {
  if (network.includes(":")) return "/images/icon-logo-ton.svg";
  return "/images/icon-logo-evm.svg";
}

export function getLogoByWalletAddress(strAddress: string) {
  if (strAddress.startsWith("0x")) return "/images/icon-logo-evm.svg";
  return "/images/icon-logo-ton.svg";
}
